// extracted by mini-css-extract-plugin
module.exports = {"left":"_748cc31f ma4","right":"_2ffd8dd7 ma4","description":"_66549089","container":"_270f475a flex"};